import styled from 'styled-components';
import { ReactNode } from 'react';

type ContainerSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';

interface ContainerProps {
  children: ReactNode;
  size?: ContainerSize;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

const sizeMap = {
  sm: 'var(--container-sm)',
  md: 'var(--container-md)',
  lg: 'var(--container-lg)',
  xl: 'var(--container-xl)',
  '2xl': 'var(--container-2xl)',
  full: '100%',
};

const StyledContainer = styled.div<{ $maxWidth: string }>`
  width: 100%;
  max-width: ${props => props.$maxWidth};
  margin: 0 auto;
  padding: 0 var(--space-6);

  @media (max-width: 768px) {
    padding: 0 var(--space-4);
  }
`;

export function Container({
  children,
  size = 'xl',
  className,
  as,
}: ContainerProps) {
  return (
    <StyledContainer
      as={as}
      className={className}
      $maxWidth={sizeMap[size]}
    >
      {children}
    </StyledContainer>
  );
}
